import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TopNav, SideNav } from '../navigation/ConsoleNavigation';
import GenbiWorkspace from './GenbiWorkspace';

/**
 * Standalone /genbi route. Owns the console shell and translates router state
 * into the slrEntry prop, so GenbiWorkspace never reads the router itself.
 */
const GenbiDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Memoised so the identity is stable across renders — GenbiWorkspace's SLR
  // effects key off this object, and a fresh literal each render would re-run them.
  const slrEntry = useMemo(() => {
    const s = location.state;
    if (!s?.fromSLR || !s?.slrFabricId) return null;
    return {
      fromSLR: true,
      slrFabricId: s.slrFabricId,
      slrTemplateName: s.slrTemplateName || null,
      templateId: s.templateId || null,
      action: s.action || null,
      templateStructure: s.templateStructure || null,
      reportDocsThreadId: s.reportDocsThreadId || null,
      fabricIdForTextractor: s.fabricIdForTextractor || null,
    };
  }, [location.state]);

  return (
    <div className="main-window">
      <TopNav />
      <div className="container-fluid has-inner-panel">
        <div className="row">
          <SideNav />
          <main className="col-12 col-md-9 col-lg-10 ms-sm-auto console-main-window">
            <div>
              <GenbiWorkspace
                slrEntry={slrEntry}
                onExit={() => navigate(-1)}
              />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default GenbiDashboard;